import { IGetEligibleCandidatesPayload } from '../../types';

export const factoryGetEligibleCandidatesKey = (payload: IGetEligibleCandidatesPayload) =>
  ['GET_ELIGIBLE_CANDIDATES', payload.postingId] as const;
